import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConfigService } from '../../../../core';
import { isModoCentralCompraCadastro } from '../../../../models/modo-central-compra';
import { ConfigEmpresa } from '../../../configuracoes/app/empresa';
import { PessoaTipo, pessoaCentralCompras, pessoaFisica, pessoaJuridica } from '../pessoa-tipo';

@Component({
    selector: 'sgt-pessoa-tipo-card-control-radio',
    templateUrl: './pessoa-tipo-card-control-radio.component.html',
    styleUrls: ['./pessoa-tipo-card-control-radio.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PessoaTipoCardControlRadioComponent), multi: true },
    ]
})
export class PessoaTipoCardControlRadioComponent implements OnInit {
    configEmpresa: ConfigEmpresa;

    /** ID do tipo da pessoa */
    @Input() ngModel: number;
    /** Ao alterar o tipo da pessoa */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Tipo da pessoa */
    @Input() tipo: PessoaTipo;
    @Output() tipoChange = new EventEmitter<PessoaTipo>();

    /** Tipos de pessoa */
    tipos: PessoaTipo[] = [];

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Mensagem de erro do required */
    @Input() msgErrorRequired = 'O tipo é obrigatório';
    /** Se deve exibir o tipo de Central de Compras */
    @Input() isShowCentralCompras = true;

    @ViewChild('controlInput') controlInput: ElementRef;

    propagateChange: any = () => {};

    constructor(private configService: ConfigService) { }

    ngOnInit(): void {
        this.configEmpresa = this.configService.getEmpresa();
        this.createTipos();
    }

    /** Cria os tipos de pessoas */
    private createTipos() {
        this.tipos = [];
        // Física
        this.tipos.push(pessoaFisica);
        // Jurídica
        this.tipos.push(pessoaJuridica);
        // Cental de Compras
        if (this.isShowCentralCompras && isModoCentralCompraCadastro(this.configEmpresa.modoCentralCompra)) {
            this.tipos.push(pessoaCentralCompras);
        }
    }

    /** Ao alterar o tipo da pessoa */
    onChange(id: number) {
        this.ngModel = id;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.tipo = this.tipos?.find(tipoFilter => tipoFilter.id === id);
        this.tipoChange.emit(this.tipo);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.controlInput?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
